export const URLS = {
  devicesPurchased:
    'https://www.hp.com/us-en/shop/AccountMyDevicesView?catalogId=10051&langId=-1&storeId=10151',
  deviceSupportNotShown: 'https://support.hp.com',
  accessSmartAdminPortal: 'https://admin.hpsmart.com/',
  accessPrintOS: ' https://www.printos.com/',
  viewOrAddPrinter: 'https://www.hpsmart.com/ucde/my-printers',
  requestPersonalData: (country: string, language: string): string =>
    `https://www.hp.com/${country}/${language}/privacy/privacy-faq.html?jumpid=in_R11928_/${country}/${language}/corp/privacy-central/privacy-faq`,
  checkSerialNoBiosUuid: (country: string, language: string): string =>
    `https://support.hp.com/${country}-${language}/document/ish_3900499-3190557-16`,
  learnMoreAboutLargeFormatPrinters: `https://kaas.hpcloud.hp.com/pdf-public/pdf_12846750_en-US-1.pdf`
};
